<template>

  <v-app>
    <v-navigation-drawer
      app
      v-model='drawer'
      temporary
      >
      <v-card class="mx-auto">
        <v-card-title class='px-0 py-0'>
          <v-toolbar
            color="deep-purple"
          >
          <v-app-bar-nav-icon @click="drawer=!drawer" alt="Hot Linux">
          </v-app-bar-nav-icon>

            <a href="/" style='color:white;text-decoration:none;'>Hot Linux</a>
          </v-toolbar>
        </v-card-title>
        <v-card-text class='mt-0'>
          <v-list>
            <!-- <v-list-item-group> -->
              <v-list-item key="1" to="/" color='primary'>
                <v-list-item-title>
                  主なサービス
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-account-wrench-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="2" to="/flow" color='primary'>
                <v-list-item-title>
                  ご相談から納品まで
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-truck-check-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="3" to="/sales" color='primary'>
                <v-list-item-title>
                  販売商品
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-cart-outline</v-icon>
                </template>
              </v-list-item>
              <!--
              <v-list-item key="4" to="/column" color='primary'>
                <v-list-item-title>
                  日々のコラム
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-calendar-month</v-icon>
                </template>
              </v-list-item>
              -->
              <v-list-item key="5" to="/trackrecord" color='primary'>
                <v-list-item-title>
                  開発事例
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="6" to="/qanda" color='primary'>
                <v-list-item-title>
                  よくある質問
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-message-question-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="7" to="/customercomments" color='primary'>
                <v-list-item-title>
                  お客様の声
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-account-tie-voice-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="8" to="/inquiryform" color='primary'>
                <v-list-item-title>
                  お問い合わせ
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-email-edit-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="9" to="/businessinfo" color='primary'>
                <v-list-item-title>
                  事業者概要
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon color=''>mdi-map-marker-outline</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="10" to="/privacypolicy" color='primary'>
                <v-list-item-title>
                  PrivacyPolicy
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-shield-key-outline</v-icon>
                </template>
              </v-list-item>
              <!--
              <v-list-item key="11" to="/repayment" color='primary'>
                <v-list-item-title>
                  返金について
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-arrow-u-left-top</v-icon>
                </template>
              </v-list-item>
              -->
              <v-divider></v-divider>
              <v-list-item key="12" href="https://hot-linux.app/" target='sample' color='primary'>
                <v-list-item-title>
                  システム例
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="12" href="https://hot-linux.pro/" target='pro' color='primary'>
                <v-list-item-title>
                  代表の想い
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="12" href="https://hot-linux.jp/" target='service' color='primary'>
                <v-list-item-title>
                  人気サービス
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
              <v-list-item key="12" href="https://hot-linux.net/" target='gce' color='primary'>
                <v-list-item-title>
                  GCEのメリット
                </v-list-item-title>
                <template v-slot:prepend>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </template>
              </v-list-item>
            <!-- </v-list-item-group> -->
          </v-list>
        </v-card-text>
      </v-card>
      <!-- <v-btn to="/admin">管理</v-btn> -->
    </v-navigation-drawer>
    <v-app-bar
      app
      color="deep-purple"
      elevation="4"
    >

      <v-app-bar-nav-icon @click="drawer=!drawer">

      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <a href="/" style='color:white;text-decoration:none;'>Hot Linux ／ WEBシステム開発</a>

      </v-toolbar-title>

      <v-toolbar-items class='mr-5'>

      お客様に合わせた<br>
      柔軟なシステム開発
      </v-toolbar-items>

    </v-app-bar>
    <v-main
      app
    >
      <router-view
        @overlay='toggle_overlay()'
        class='mb-5'
      ></router-view>
      <v-snackbar
        position='sticky'
        v-model="snackbar"
        timeout="-1"
        color="lime-accent-3"
      >
        <v-btn
          flat
          block
          density="compact"
          @click='onClick簡単問合せ()'
          class="lime-accent-3 font-weight-bold"
          color="lime-accent-3"

        >
          <template v-if='isMobile'>
            「あなたの困った」を即解決！
          </template>
          <template v-else>
            「あなたの困った」を即解決！Webシステム導入・開発のご相談はこちら
          </template>
        </v-btn>
      </v-snackbar>
      <v-dialog
        max-width='800'
        v-model='show簡単問い合わせ'
      >
        <v-card>
          <v-card-title
            class='primary'
          >
          「あなたの困った」を解決します<br><span class='text-caption'>メールアドレスだけでご相談受付ができます</span>
          </v-card-title>
          <v-card-text
            class="overflow-y-auto"
          >
            <v-form v-model='valid' ref=mailForm>
              <v-text-field
                label='メールアドレス'
                v-model='メールアドレス'
                :rules="emailRules"
                variant="outlined"
              ></v-text-field>

              <v-divider
                class='my-5'
              ></v-divider>
              <v-row>
                <v-col>
                  ご希望のお問い合わせ方法
                </v-col>
              </v-row>
            </v-form>
            <v-radio-group v-model='返信形式'>
              <v-row>
                <v-col cols='12' md='4'>
                  <v-radio
                    value='メール'
                    label='メール'></v-radio>
                <span class='text-caption'>入力したメールアドレスに問い合わせ用のメールテンプレートが届きます。そのメールにお問い合わせ内容を記入して返信してください</span>
                </v-col>
                <v-col cols='12' md='4'>
                  <v-radio
                    value='Slack'
                    label='Slack'></v-radio>
                    <span class='text-caption'>入力したメールアドレスをSlack（チャットツール）のDMに招待いたします。</span>
                </v-col>
                <v-col cols='12' md='4'>
                  <v-radio
                    value='Chatwork'
                    label='Chatwork'></v-radio>
                    <span class='text-caption'>入力したメールアドレスをChatwork（チャットツール）のDMに招待いたします。</span>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-btn
              :disabled='!valid'
              block
              class='mb-4'
              color='primary'
              @click='onClick送信()'
            >
              送信する
            </v-btn>
            <v-row class='my-5'>
              <v-col>
                <v-divider
              
                ></v-divider>
              </v-col>
              <v-col cols='auto'>
                または
              </v-col>
              <v-col>
                <v-divider
                ></v-divider>
              </v-col>
            </v-row>
            <v-btn
              block
              color="success"
              @click='onClickLine()'
              >LINEで相談する</v-btn>
            <v-btn
              class='mt-10'
              block

              @click='show簡単問い合わせ=false'
              >閉じる</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
    <v-footer
      app
       class="d-flex flex-column"
       color="deep-purple"
      >
      <div class='w-100 text-right'>
        Copyright 2024 <a href="/" style='color:white;text-decoration:none;'>Hot Linux</a>
      </div>
      
    </v-footer>
    <loading
      v-model:active="overlay"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="fullPage">
    </loading>
    <!-- フロートのチャットウインドウを作る -->
    <v-btn
      fab
      dark
      color="lime-accent-3"
      @click="toggleChat"
      class="chat-toggle-btn"
    >

      <v-icon>{{ chatOpen ? 'mdi-close' : 'mdi-chat' }}</v-icon>
      Web導入＆開発サポート
    </v-btn>
    <v-card
      v-if="chatOpen"
      class="chat-window "
      elevation="10"
      :style="{width: isMobile ? '90vw' : '50vw'}"

    >
      <v-card-title class="headline bg-lime-accent-3">
        <v-icon>mdi-chat</v-icon>
        WEB導入＆開発サポート<span class='text-caption'>({{ modelId }})</span>
        <v-btn
          icon
          @click="toggleChat"
          class="close-chat-btn"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>疑問点や不安点をAIに聞いてみよう！（「機密情報」や「個人情報」の入力は避けてください）</v-card-subtitle>
      <v-card-text>
        <div style="max-height:50vh;overflow: auto;" class="py-4">
          <v-row dense v-for="(row,index) in contents" :key="index" :class="row.role === 'user' ? 'justify-end':'justify-start'" >
            <v-col cols="12" sm="8">
              <v-sheet
                class="pa-2 white--text rounded-lg shadow"
                :class="row.role === 'user' ? 'text-right bg-blue-lighten-4' : 'text-left  bg-green-lighten-4'"
                style="white-space: pre-wrap;position: relative;"
                >
                <template v-for="(part,index) in row.parts">
                  <div v-if = '!!part.text' :key="index+'_text'">{{ part.text }}</div>
                  <v-img v-if='!!part.inlineData' :src='"data:"+part.inlineData.mime+";base64,"+part.inlineData.data' :key="index+'_img'"></v-img>
                </template>
                <!--
                <v-overlay
                  contained
                  :model-value="true"
                  class="d-flex justify-center align-center"
                  :opacity="0"
                  persistent
                  style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
                >
                  <v-icon
                    color="primary"
                    size="large"
                    @click="contentCopy(row)"
                    style="opacity:0.5;"
                  >
                    mdi-content-copy
                  </v-icon>
                </v-overlay>
                -->
                <v-icon
                  color="white"
                  size="large"
                  @click="contentCopy(row)"
                >
                  mdi-content-copy
                </v-icon>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-textarea
              v-model='inputText'
              label='AIに質問する'
              rows="1"
              ref="inputTextarea"
              density="comfortable"
              :auto-grow="true"
              @keydown.enter="handleKeydown"
              >
              <template v-slot:append>
                <v-icon
                  @click='vertexai接続()'
                  block
                  class="text-h4 ml-2"
                >mdi-send-variant-outline</v-icon>
              </template>
              <template v-slot:details>
                <div class="text-caption text-right pr-2">Shift+Enterで送信</div>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-app>
</template>

<script>

import Loading from 'vue-loading-overlay'
export default {
  name: 'App',
  components: {
    Loading
  },
  data(){
    return{
      selectedItem:0,
      drawer:false,
      snackbar:true,
      overlay:false,
      fullPage:true,
      show簡単問い合わせ:false,
      返信形式:'メール',
      メールアドレス:"",
      valid:false,
      inputText:"",
      //modelId:"gemini-2.0-flash-exp",
      //modelId:"gemini-2.0-flash-thinking-exp-01-21",
      //modelId:"gemini-2.0-pro-exp-02-05",
      modelId:"gemini-2.5-pro-exp-03-25",

      chatOpen: true,
      contents: [],
      emailRules:[
        v => !!v || "必須です",
        v => /.+@.+/.test(v) || '形式が違います',
      ],
      isMobile: false,
    };
  },

  mounted(){
    this.isMobile = window.innerWidth < 800;
  },

  methods:{
    toggle_overlay:function(){
      this.overlay = !this.overlay;
    },

    onClick簡単問合せ(){
      this.show簡単問い合わせ = true;
      this.$gtag.event("conversion",{
        'send_to':'AW-10896111516/LkydCImpjqIZEJzv1cso',
        'value':1,
        'currency':'JPN'
      })
    },

    onClick送信(){
      //this.$emit('overlay');
      this.toggle_overlay();
      let url = '../api/api.php';
      let data = {
        func:"簡単問い合わせ保存",
        メールアドレス:this.メールアドレス,
        返信形式:this.返信形式,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        console.log("相談result",result);
        this.$refs.mailForm.reset();
        this.返信形式 = "Slack"
        this.$emit('overlay');
        alert("ご相談ありがとうございます。一両日中にはご希望の返信形式で返信いたします。少々お待ちください。");
      })
      .catch(error =>{
        alert('送信できませんでした。\n\n'+error.body);
        console.log("相談error",error)
        //this.$emit('overlay');
      })
      .finally(() => {
        this.toggle_overlay()
      })
    }, 

    onCancel(){

    },

    onClickLine(){
      window.open("https://lin.ee/XRhQTGa")
    },
    // チャット関連
    toggleChat() {
      this.chatOpen = !this.chatOpen;
    }, 

    vertexai接続() {

      let url = '../api/api.php';
      this.inputText = this.inputText.trim();
      if(!this.inputText){
        return;
      }
      this.overlay = true;
      let data = {
        "func":"vertexai接続",
        "inputText":this.inputText,
        "modelId":this.modelId,
        "contents":this.contents,
      }

      console.log("vertexai接続req",data)

      let param = {
        method : "POST",
        body : JSON.stringify(data),
        headers:{"X-CSRF-TOKEN": '{{ csrf_token() }}' ,"Content-Type": "application/json",},
      }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.resultText = result.candidates[0].content.parts[0].text;
        console.log("vertexai接続result",result)

        let content = {
          role:"user",
          parts:[
            {"text":this.inputText},
          ]
        }

        this.contents.push(content)

        //回答をcontentsに追加
        this.contents.push({
          role:"model",
          parts:[
            {text:this.resultText}
        ]})
        this.inputText = '';
        //this.contentsの数が100を超えていたら、100になるまで先頭から削除する。ループで削除。
        while (this.contents.length > 100) {
          this.contents.shift();
        }
        this.img_src = null;
        this.imgKey++;
        this.upload_file = null;
        console.log("contents",this.contents);
      })
      .catch(error =>{

        console.log("vertexai接続error",error);
        this.resultText = "エラーが発生しました。\n"+error.body;
      })
      .finally(()=>{
        this.overlay = false;
      })
    },
    handleKeydown(e){
      if(e.shiftKey && !!this.inputText){
        e.preventDefault();
        this.vertexai接続();
      }
    },
    contentCopy(row){
      navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
        if (result.state === "granted" || result.state === "prompt") {
          /* write to the clipboard now */
        }
      });

      const textToCopy = row.parts.map(part => part.text).join('\n');
      setTimeout(() => {
        (async () => {
          try {
            await navigator.clipboard.writeText(textToCopy);
            console.log('Text copied to clipboard');
            alert('コピーしました');
          } catch (err) {
            console.error('Failed to copy: ', err);
            alert('コピーに失敗しました');
          }
        })();
      }, 0);
    },

  }
}
</script>



<style>


#app {
  font-family: "M PLUS Rounded 1c","M PLUS 2","Kosugi Maru",Avenir, Helvetica, Arial, sans-serif;
  /*
  font-family: "M PLUS 1p","Kiwi Maru","M PLUS Rounded 1c","M PLUS 2","Kosugi Maru",Avenir, Helvetica, Arial, sans-serif;
  */

  /*
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  */
}
.chat-toggle-btn {
  position: fixed;
  bottom: 80px; /* フッターに被らないように調整 */
  right: 20px;
  background-color: #ffeb3b; /* 明るい黄色に変更 */
  color: #000; /* テキストカラーを黒に */
  border-radius: 8px; /* 角を丸くする */
  padding: 10px 20px; /* パディングを追加 */
  font-weight: bold; /* フォントを太く */
}

.chat-window {
  position: fixed;
  bottom: 60px;
  right: 20px;
  width: 50vw;
  /*max-height: 500px;
  overflow-y: auto;
  */
}

.close-chat-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px !important; /* ボタンの幅を小さく */
  height: 24px !important; /* ボタンの高さを小さく */
  min-width: 24px !important; /* 最小幅を設定 */
  min-height: 24px !important; /* 最小高さを設定 */
}
</style>
